export const MY_PROFILE_TRANSLATE = {
    myProfile: {
        breadcrumbName: "Mi Perfil",
        messages: {
            changePassword: "Contraseña cambiada exitosamente"
        },
        read: {
            tabs: {
                data: "General",
                changePassword: "Cambiar contraseña"
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese su nombre"
                    },
                    email: {
                        label: "Correo electrónico",
                        placeholder: "Ingrese su correo electrónico"
                    },
                    currentPassword: {
                        label: "Contraseña actual",
                        placeholder: "Ingrese su contraseña actual"
                    },
                    password: {
                        label: "Nueva contraseña",
                        placeholder: "Ingrese su nueva contraseña"
                    },
                    passwordConfirmation: {
                        label: "Confirmar nueva contraseña",
                        placeholder: "Confirme su nueva contraseña"
                    }
                }
            }
        }
    }
}
